var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nuxt-error error-content"},[_c(_vm.errorPage,{tag:"component",attrs:{"error":_vm.error}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }